import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useAgreementsAiSearchStore } from './useAgreementsAiSearchStore';
const EMPTY = [];
const PAGE_LIMIT = 200;
const hasActiveFilter = (filter)=>Object.entries(filter).some((param)=>{
        let [key, value] = param;
        return key !== 'version' && value != null && !(Array.isArray(value) && value.length === 0);
    });
export const useAgreementsAiSearchResults = (param)=>{
    let { businessId, isVendor, enabled = true } = param;
    var _ref, _ref1;
    const { api } = useStoreActions();
    const filter = useAgreementsAiSearchStore((s)=>s.filter);
    const setError = useAgreementsAiSearchStore((s)=>s.setError);
    const isActive = enabled && filter != null && hasActiveFilter(filter);
    const { data, isFetching, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.AgreementsAiSearchResults,
            filter,
            businessId,
            isVendor
        ],
        queryFn: (param)=>{
            let { signal } = param;
            if (filter == null) throw new Error('agreements AI-search query enabled without a filter');
            return api.relationship.searchSummaries({
                businessId,
                filter,
                isVendor,
                limit: PAGE_LIMIT,
                signal
            });
        },
        enabled: isActive,
        staleTime: 0,
        cacheTime: 0,
        onError: ()=>setError('search_failed'),
        onSuccess: ()=>setError(null)
    });
    const agreements = (_ref = data === null || data === void 0 ? void 0 : data.entries) !== null && _ref !== void 0 ? _ref : EMPTY;
    return {
        agreements,
        isActive,
        isFetching,
        isLoading,
        refresh,
        renderedCount: agreements.length,
        totalMatchCount: (_ref1 = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _ref1 !== void 0 ? _ref1 : 0
    };
};
